<template>
    <b-modal
        size="xl"
        v-model="modalShow"
        :title="$locale.question"
        ok-only
        ok-title="閉じる"
        ok-variant="yokumiru-gray"
        @ok="close"
        @hidden="close">
        <div class="t-admin">
            <div
                v-if="inProgress"
                class="d-flex justify-content-center align-items-center m-5 p-5">
                <b-spinner variant="yokumiru-admin"/>
            </div>
            <div
                v-else-if="hasMatchingAnswer"
                v-for="answer in interviewMatchingAnswers">
                <dt>{{ answer.title }}</dt>
                <dd class="u-mb3 pre-wrap">{{ answer.content || '-' }}</dd>
            </div>
        </div>
    </b-modal>
</template>

<script>
import YokumiruHelper from '../../../YokumiruHelper'
import constants from '../../../constants'

export default {
    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            modalShow: false,
            consultation: null,
            interviewMatchingAnswers: null,
            timezone: 'Asia/Tokyo',
            errors: {},
        }
    },

    computed: {
        hasMatchingAnswer: function () {
            return this.interviewMatchingAnswers && this.interviewMatchingAnswers.length > 0
        },
    },

    created: function () {
        bus.$on('open-modal-admin-matching-interview-answers', this.open)
        bus.$on('admin-doctor-matching-completed', this.close)
    },

    beforeDestroy: function () {
        bus.$off('open-modal-admin-matching-interview-answers')
        bus.$off('admin-doctor-matching-completed')
    },

    methods: {
        /**
         * モーダル表示
         * @param {object} consultation
         */
        open: function (consultation) {
            this.consultation = consultation
            this.fetchInterviewAnswers()
            this.modalShow = true
        },

        /**
         * モーダルを閉じる
         */
        close: function () {
            this.modalShow = false
        },

        /**
         * 問診回答一覧
         */
        fetchInterviewAnswers: async function () {
            if (this.inProgress) return
            this.inProgress = true

            this.interviewMatchingAnswers = null
            const endpoint = `${constants.admin.consultations.endpoint.base}/${this.consultation.id}/answers`

            await axios.get(`${endpoint}/matching`)
                .then(({data}) => {
                    this.interviewMatchingAnswers = data
                })

            this.inProgress = false
        },
    },
}
</script>

<style scoped lang="scss">
</style>
